import * as AppearanceGlobalAssetsActions from '../store/actions/appearanceGlobalAssetsActions';
import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  actionCreate: AppearanceGlobalAssetsActions.createAppearanceGlobalAssets,
  actionUpdate: AppearanceGlobalAssetsActions.updateAppearanceGlobalAssets,
  actionGetDraftId: AppearanceGlobalAssetsActions.getDraftId,
  storeNode: storeStructure.AppearanceGlobalAssets,
  title: 'Whitelabel play (new)',
  fields: [
    {
      attributeName: 'wlpPrimaryColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Primary Color',
      helpText: 'Primary color used for Whitelabel Play app',
    },
    {
      attributeName: 'wlpSecondaryColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Secondary Color',
      helpText: 'Secondary color used for Whitelabel Play app',
    },
    {
      attributeName: 'wlpTextOnPrimary',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Text on Primary',
      helpText: 'Text color when displayed over primary color',
    },
    {
      attributeName: 'wlpTextOnSecondary',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Text on Secondary',
      helpText: 'Text color when displayed over secondary color',
    },
    {
      attributeName: 'wlpBackground',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Background',
      helpText: 'Background color for Whitelabel Play app',
    },
  ],
};
